// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//window.Vue = require('vue');
import Vue from 'vue';
import App from './App'
import router from './router'

import axios from 'axios';
import VueAxios from 'vue-axios';

import nb_NO from 'vee-validate/dist/locale/nb_NO';
import VeeValidate, { Validator } from 'vee-validate';

Vue.use(VeeValidate);
Validator.localize('nb_NO', nb_NO);

Vue.config.productionTip = false

Vue.use(VueAxios, axios);

if (window.location.hostname == 'localhost') {
  Vue.axios.defaults.baseURL = 'http://localhost:8000/api';
} else {
  Vue.axios.defaults.baseURL = window.location.protocol +  '//' + window.location.hostname + '/api';
}

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  tokenDefaultName : 'sosmessages',
  fetchData: { url: 'caller/me', method: 'GET', enabled: true },
  refreshData: { url: 'caller/refresh', method: 'GET', enabled: true, interval: 30 }
})

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router
})



// WEBPACK FOOTER //
// ./src/main.js